import { render, staticRenderFns } from "./admin-contract-templates.vue?vue&type=template&id=6586d12a&scoped=true"
import script from "./admin-contract-templates.vue?vue&type=script&lang=js"
export * from "./admin-contract-templates.vue?vue&type=script&lang=js"
import style0 from "./admin-contract-templates.vue?vue&type=style&index=0&id=6586d12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586d12a",
  null
  
)

export default component.exports